import apiClient from './api';

export interface MeituanShop {
  id: string;
  shopId: string;
  shopName: string;
  businessId?: string;
  state?: string;
  opBizCode?: string;
  opBizName?: string;
  authCode?: string;
  accessToken: string;
  refreshToken: string;
  scope: string;
  tokenExpiresAt?: string;
  authorizedAt?: string;
  status: number;
  autoAcceptOrder: number;
  autoConfirmChange: number;
  sort: number;
  remark: string;
  createdBy?: string;
  updatedBy?: string;
  createdAt: string;
  updatedAt: string;
}

export interface MeituanShopListParams {
  page?: number;
  pageSize?: number;
  keyword?: string;
  status?: string;
  availableForUserId?: string;
}

export interface MeituanShopAuthUrl {
  authUrl: string;
  businessId: string;
  businessName: string;
  timestamp: number;
}

export type SaveMeituanShopRequest = Omit<
  MeituanShop,
  | 'id'
  | 'accessToken'
  | 'refreshToken'
  | 'tokenExpiresAt'
  | 'authorizedAt'
  | 'createdBy'
  | 'updatedBy'
  | 'createdAt'
  | 'updatedAt'
>;

export const listMeituanShops = (params: MeituanShopListParams) => (
  apiClient.get<{ list: MeituanShop[]; total: number }>('/meituan-shops', { params })
);

export const getMeituanShopAuthUrl = (businessId: string) => (
  apiClient.get<MeituanShopAuthUrl>('/meituan-shops/auth-url', { params: { businessId } })
);

export const refreshMeituanShopToken = (id: string, businessId?: string) => (
  apiClient.post<MeituanShop>(`/meituan-shops/${id}/refresh-token`, { businessId })
);

export const updateMeituanShop = (id: string, data: SaveMeituanShopRequest) => (
  apiClient.put<MeituanShop>(`/meituan-shops/${id}`, data)
);

export const deleteMeituanShop = (id: string) => (
  apiClient.delete(`/meituan-shops/${id}`)
);
